import {Link} from "react-router-dom";

export default function NavBar() {

    function Click() {
        window.scrollTo(0, 0)
    }


    return (
        <header className="sticky xl:navbar top-0 z-50 bg-base-100/90 shadow-md">
            <nav className="xl:flex xl:justify-start xl:content-end xl:mx-auto max-xl:grid max-xl:grid-cols-3
            max-xl:grid-flow-cols-dense ">

                <div className="xl:hidden inline px-2 py-2 col-end self-center max-xl:visible xl:invisible">
                    <div className="dropdown dropdown-hover">
                        <label tabIndex={0}
                               htmlFor="nav-drawer"
                               className="drawer-button btn btn-square btn-ghost text-accent-900 hover:bg-primary-focus/80 hover:text-base-200/100">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-5 h-5 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                        </label>
                        <ul tabIndex={0}
                            className="dropdown-content menu lg:menu-normal bg-base-100 w-72 rounded-box shadow-md">
                            <li className="">
                                <Link to="/"
                                      className="font-semibold text-md px-4 py-4 text-accent-900 hover:bg-primary hover:text-base-200/100"
                                      onClick={Click} >Startseite</Link>
                            </li>
                            <li className="">
                                <Link to="/team"
                                      className="font-semibold text-md px-4 py-4 text-accent-900 hover:bg-primary hover:text-base-200/100"
                                      onClick={Click}>Team</Link>
                            </li>

                            <li className="">
                                <Link to="/leistungen"
                                      className="font-semibold text-md px-4 py-4 text-accent-900 hover:bg-primary hover:text-base-200/100"
                                      onClick={Click}>Leistungen</Link>
                            </li>
                            <li className="">
                                <Link to="/bewerbung"
                                      className="font-semibold text-md px-4 py-4 text-accent-900 hover:bg-primary hover:text-base-200/100"
                                      onClick={Click}>Stellenausschreibung</Link>
                            </li>
                            <li className="divider"></li>
                            <li className="">
                                <Link to="/ueberuns"
                                      className="font-semibold text-md px-4 py-4 text-accent-900 hover:bg-primary hover:text-base-200/100"
                                      onClick={Click}>Über Uns</Link>
                            </li>
                            <li className="">
                                <Link to="/sprechstunden"
                                      className="font-semibold text-md px-4 py-4 text-accent-900 hover:bg-primary hover:text-base-200/100"
                                      onClick={Click}>Sprechstunden</Link>
                            </li>
                            <li className="">
                                <Link to="/notfall"
                                      className="font-semibold text-md px-4 py-4 text-accent-900 hover:bg-primary hover:text-base-200/100"
                                      onClick={Click}>Bei Notfällen</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="xl:hidden inline px-2 py-2 max-xl:visible xl:invisible"></div>


                <div className="xl:flex xl:flex-row max-xl:px-2 max-xl:py-2 max-xl:self-center">
                    <img className="xl:flex-none w-52 xl:w-80 " src="/Praxis_banner.svg" alt="Logo"/>
                </div>

                <div className="px-8 invisible xl:visible"></div>
                <Link to="/"
                   className="group hidden xl:inline font-bold text-xl px-5 py-6 text-accent-900 hover:bg-primary hover:text-base-200/100
                   invisible xl:visible" onClick={Click} >
                    <div className="group-hover:scale-110 transform transition ">
                        Startseite
                    </div>
                </Link>
                <Link to="/team"
                   className="group hidden xl:inline font-bold text-xl px-5 py-6 text-accent-900 hover:bg-primary hover:text-base-200/100
                   invisible xl:visible" onClick={Click}>
                    <div className="group-hover:scale-110 transform transition ">
                        Team
                    </div>
                </Link>
                <Link to="/leistungen"
                   className="group hidden xl:inline font-bold text-xl px-5 py-6 text-accent-900 hover:bg-primary hover:text-base-200/100
                   invisible xl:visible" onClick={Click}>
                    <div className="group-hover:scale-110 transform transition ">
                        Leistungen
                    </div>
                </Link>
                <Link to="/bewerbung"
                   className="group hidden xl:inline font-bold text-xl px-6 py-6 text-accent-900 hover:bg-primary hover:text-base-200/100
                   invisible xl:visible"
                      onClick={Click}>
                    <div className="group-hover:scale-110 transform transition ">
                        Stellenausschreibung
                    </div>
                </Link>
                <div className="hidden xl:inline invisible xl:visible px-8"></div>

                <Link to="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin"
                      target="_blank" rel="noopener noreferrer" className="group hidden xl:inline font-bold text-l px-4 py-4 mr-8 text-accent-900 bg-blue-900 text-base-200/100
                   invisible xl:visible absolute right-0 rounded-box"
                      onClick={Click}>
                    <div className="group-hover:scale-110 transform transition">
                    <span className="flex">Mit
                    <img className="w-20" src="https://www.doctolib.de/external_button/doctolib-white-transparent.png" alt="Doctolib Logo"/>
                    </span>
                        Termin buchen
                    </div>
                </Link>
            </nav>

            <div className="md:invisible fixed right-0 bottom-36 flex-col items-center justify-center content-center bg-blue-900 p-2 md:p-4 text-white
            rounded-l-xl">
                <div className="pb-3 flex justify-center">
                    <img className="md:w-28 w-20" src="https://www.doctolib.de/external_button/doctolib-white-transparent.png" alt="Doctolib Logo"/>
                </div>
                <div className="p-2 flex justify-center rounded-box bg-secondary hover:text-neutral-900">
                    <a href="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin"
                       className="text-xs font-bold" target="_blank" rel="noopener noreferrer" aria-label="Termin über Doctolib buchen">
                        Termin
                    </a>
                </div>
                <div className="p-2"></div>
                <div className="p-2 flex justify-center rounded-box bg-secondary hover:text-neutral-900">
                    <a href="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin/patient-request?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin/patient-request-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin/patient-request"
                       className="text-xs font-bold" target="_blank" rel="noopener noreferrer" aria-label="Nachricht an Praxis über Doctolib senden">
                        Nachricht
                    </a>
                </div>
            </div>

            <div className="invisible md:visible xl:invisible fixed right-0 bottom-28 flex-col items-center justify-center content-center bg-blue-900 p-2 md:p-4 text-white
            rounded-l-xl">
                <div className="pb-6 flex justify-center">
                    <img className="md:w-28 w-20" src="https://www.doctolib.de/external_button/doctolib-white-transparent.png" alt="Doctolib Logo"/>
                </div>
                <div className="p-2 flex justify-center rounded-box bg-secondary hover:text-neutral-900">
                    <a href="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin"
                       className="text-md font-bold" target="_blank" rel="noopener noreferrer" aria-label="Termin über Doctolib buchen">
                        Termin buchen
                    </a>
                </div>
                <div className="p-2"></div>
                <div className="p-2 flex justify-center rounded-box bg-secondary hover:text-neutral-900">
                    <a href="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin/patient-request?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin/patient-request-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin/patient-request"
                       className="text-md font-bold" target="_blank" rel="noopener noreferrer" aria-label="Nachricht an Praxis über Doctolib senden">
                        Nachricht senden
                    </a>
                </div>
            </div>

            <div className="fixed right-0 bottom-14 invisible xl:visible duration-200 ease-in-out hover:scale-125 ">
                <a href="https://www.doctolib.de/praxis/biebergemuend/praxis-dr-med-thomas-bonin/patient-request?utm_campaign=website-button&amp;utm_source=praxis-dr-med-thomas-bonin/patient-request-website-button&amp;utm_medium=referral&amp;utm_content=option-8&amp;utm_term=praxis-dr-med-thomas-bonin/patient-request"
                   className="font-bold" target="_blank" rel="noopener noreferrer" aria-label="Nachricht an Praxis über Doctolib senden">
                    <div className="p-5 flex justify-center bg-blue-900 text-white rounded-full mr-6">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                             className="" viewBox="0 0 16 16">
                            <path
                                d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
                            <path
                                d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2"/>
                        </svg>
                    </div>
                </a>
            </div>
        </header>
    )
}

/*
<div className="drawer drawer-end">
  <input id="nav-drawer" type="checkbox" className="drawer-toggle" />
  <div className="drawer-content">
    <!-- Page content here -->
    <label htmlFor="nav-drawer" className="drawer-button btn btn-primary">Open drawer</label>
  </div>
  <div className="drawer-side">
    <label htmlFor="nav-drawer" className="drawer-overlay"></label>
    <ul className="menu p-4 w-80 bg-base-100 text-base-content">
      <!-- Sidebar content here -->
      <li><a>Sidebar Item 1</a></li>
      <li><a>Sidebar Item 2</a></li>
    </ul>
  </div>
</div>

<button className="btn btn-square btn-ghost ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-5 h-5 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                    </button>
 */